import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-affiliate-modal',
  templateUrl: './affiliate-modal.component.html',
  styleUrls: ['./affiliate-modal.component.scss'],
})
export class AffiliateModalComponent {
  constructor(
    private dialogRef: MatDialogRef<AffiliateModalComponent>,
    private api: UserApiService,
    private message: MessageService
  ) {}

  loading = false;
  async changeAffiliateModal() {
    try {
      this.loading = true;
      const r = await this.api.changeAffiliateModal();
      if (r.status === 0) {
        this.dialogRef.close();
      } else {
        this.message.warn('未知错误');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
